angular.module('workflow.app')
  # Angular date/datetime format
  .constant('arachnysDatePickerOutputFormat', 'dd MMM yyyy')
  # moment.js date/datetime formats
  .constant('arachnysOutputDateFormat', 'DD MMM YYYY')
  .constant('arachnysOutputDateTimeFormat', 'DD MMM YYYY, HH:mm')
  .constant('arachnysAcceptableDateInputFormats', [
    "D MMM YYYY",   # 1 Jan 2015
    "DD MMM YYYY",  # 01 Jan 2015
    "YYYY-M-D",     # 2015-1-1
    "YYYY/M/D",     # 2015/1/1
    "D/M/YYYY",     # 1/1/2015
    "D-M-YYYY"      # 1-1-2015
  ])
  .constant('arachnysMinDate', "1900-01-01") # Min date for python 2.7 datetime.strftime
  .constant('arachnysMaxDate', "9999-12-31") # Max django datetime
